(() => {
  if (window.kehwahMediaMotionReady) return;
  window.kehwahMediaMotionReady = true;
  const controllers = new Map();
  const initialise = (root = document) => {
    root.querySelectorAll('[data-muted-autoplay="true"]').forEach(container => {
      if (controllers.has(container)) return;
      const video = container.querySelector('video');
      if (!video) return;
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let userPaused = false;
      let automaticPauses = 0;
      video.muted = video.defaultMuted = video.loop = video.playsInline = true;
      const pause = () => {
        if (video.paused) return;
        automaticPauses += 1;
        video.pause();
      };
      const sync = () => {
        if (!visible || document.hidden) return pause();
        if (preference.matches || userPaused || !video.paused) return;
        const playback = video.play();
        playback?.catch(() => { /* Native controls remain available. */ });
      };
      const onPause = () => {
        if (automaticPauses) automaticPauses -= 1;
        else userPaused = true;
      };
      const onPlay = () => { userPaused = false; };
      const onPreference = () => preference.matches ? pause() : sync();
      video.addEventListener('pause', onPause);
      video.addEventListener('play', onPlay);
      preference.addEventListener('change', onPreference);
      document.addEventListener('visibilitychange', sync);
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.5);
        sync();
      }, {threshold: [0, 0.5]}) : null;
      observer?.observe(video);
      controllers.set(container, () => {
        pause();
        observer?.disconnect();
        video.removeEventListener('pause', onPause);
        video.removeEventListener('play', onPlay);
        preference.removeEventListener('change', onPreference);
        document.removeEventListener('visibilitychange', sync);
      });
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((dispose, container) => {
      if (!event.target.contains(container)) return;
      dispose();
      controllers.delete(container);
    });
  });
})();
